export const CreditsVault = "console";
export interface registerData {
	username: string;
	password: string;
}

export interface loginData {
	username: string;
	password: string;
}

export interface loginByWalletData {
	walletAddress: string;
	signMessage: string;
	signStr: string;
	channelCode?: string;
	inviteCode?: string;
}

export interface recommendData {
	sortBy: number; // 1/根据联赛 默认0/根据时间id
	tabType: number; // 1/滚球 2/今日 3/早盘
	page: number;
	pageSize: number;
}

export interface leagueData {
	recommend?: number;
}

export interface searchData {
	leagueId?: number;
	teamName?: string;
	page: number;
	pageSize: number;
}

export interface resultData {
	stateDay: string;
	page: number;
	pageSize: number;
	leagueIds?: number;
	// leagueIds/查指定联赛ID的 stateDay/日期年月日
}

interface ContentItem {
	itemContent: string;
	sportType: number;
	buyType: number;
	handicap: number;
	odds: number;
	playType: number;
	marketId: number;
	bookId: number;
	itemMoney: number;
	matchId: number;
	passType: string; // passType 类型可能是 string 或 number
	isInPlay: number;
	id?: string;
}

export interface buyData {
	passType: string;
	contents: ContentItem[];
}

export interface buyItem {
	// type/1未结 2/已结 day 默认7天 0/当天 1/昨天
	type: number;
	day?: number;
	page: number;
	pageSize: number;
}

export interface PayParams {
	toAddress: string; //  接收地址
	tempAddress: string; // 合约地址
	amount: number; // 金额
	decimals: number; // 合约位数
	payAddress: string; // 授权人
	transactionData: string;
}

export interface loginByTelegramData {
	initData: string;
	chatCreateNickname: string;
	chatId: string;
	chatCreate: string;
}

export interface RecommendItem {
	orderUpdateTime: string;
	orderId: string;
	uid: number;
	status: number;
	coin: number;
	nickname: string;
	walletAddress: string;
	rewardCoin: number;
	commission: number; //佣金 只有状态为3已结算情况下才有
	effectiveWater: number; //有效流水
}

export interface AgentListData {
	uid: number;
	balance: number;
	totalCommission: number; //总返佣
	nickname: string;
	walletAddress: string;
	status: string;
	rolling: string; //返佣比例
	effective: number; //成员流水
	totalEffective: number; //下级总流水
	inviteRemake: string; //备注
}
